import {useSelector,useDispatch} from 'react-redux'
import {
	readOnDemandCategories,
	readOnDemandVideos,
	selectAllCategories,
	selectAllVideos
} from './slice'

export const useOnDemandCategories = ()=>{
	const dispatch = useDispatch()
	const status = useSelector(state=>state.onDemand.categories.status)
	const categories = useSelector(selectAllCategories).sort((a,b)=>(
		a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
	))

	if ( status === 'init' ) dispatch(readOnDemandCategories())

	return {status,categories}
}

export const useOnDemandVideos = (category_id)=>{
	const dispatch = useDispatch()
	const {status,category_id:currentCategory} = useSelector(state=>state.onDemand.videos)
	const videos = useSelector(selectAllVideos)
		//sort by name
		.sort((a,b)=>(
			a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
		))
		//filter out any vidoes not part of the category
		.filter(v=>parseInt(v.category_id)===parseInt(category_id))

	if (status==='init'||category_id!==currentCategory) {
		dispatch(readOnDemandVideos({category_id}))
	}

	return {status,videos}
}